// // src/hooks/SessionProvider.js
// import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import api from '../Service/api';

// export default function SessionProvider({ children }) {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const interval = setInterval(async () => {
//       const token = localStorage.getItem('sessionToken');
//       if (!token) {
//         navigate('/login', { replace: true });
//         return;
//       }

//       try {
//         const active = await api.get('/authentication/validate', { params: { token } });
//         if (active.data.code !== 1) {
//           alert('Session expired!');
//           localStorage.clear();
//           navigate('/login', { replace: true });
//         }
//       } catch (err) {
//         console.error('Session check failed', err);
//         localStorage.clear();
//         navigate('/login', { replace: true });
//       }
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [navigate]);

//   return children;
// }
// src/hooks/SessionProvider.js
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../Service/api'; // Use regular api, NOT productionApi

export default function SessionProvider({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('SessionProvider: Current pathname =', location.pathname);
    
    // Check if current path is the employee production page
    // Use exact match AND startsWith to handle any subpaths
    const isEmployeeProductionPage = 
      location.pathname === '/employee-production' || 
      location.pathname.startsWith('/employee-production/');
    
    console.log('SessionProvider: Is employee production page?', isEmployeeProductionPage);
    
    // If it's the employee production page, DO NOT start session checking
    if (isEmployeeProductionPage) {
      console.log('SessionProvider: Skipping session checks for employee production page');
      return; // Exit early, no interval will be set
    }

    // For all other pages, run session checking as before
    console.log('SessionProvider: Starting session checks for', location.pathname);
    
    const interval = setInterval(async () => {
      console.log('SessionProvider: Checking session...');
      const token = localStorage.getItem('sessionToken');
      if (!token) {
        console.log('SessionProvider: No token found, going to login');
        navigate('/login', { replace: true });
        return;
      }

      try {
        console.log('SessionProvider: Calling validate endpoint');
        const active = await api.get('/authentication/validate', { params: { token } });
        console.log('SessionProvider: Validation response code:', active.data.code);
        
        if (active.data.code !== 1) {
          console.log('SessionProvider: Session expired! Code is not 1');
          alert('Session expired!');
          localStorage.clear();
          navigate('/login', { replace: true });
        } else {
          console.log('SessionProvider: Session is valid');
        }
      } catch (err) {
        console.error('SessionProvider: Session check failed', err);
        console.log('SessionProvider: Clearing localStorage and going to login');
        localStorage.clear();
        navigate('/login', { replace: true });
      }
    }, 5000);

    return () => {
      console.log('SessionProvider: Cleaning up interval');
      clearInterval(interval);
    };
  }, [navigate, location.pathname]); // Add location.pathname to dependencies

  return children;
}